"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOTLOGIN = exports.ISUSER = void 0;
var ISUSER = 'ISUSER';
exports.ISUSER = ISUSER;
var NOTLOGIN = 'NOTLOGIN';
exports.NOTLOGIN = NOTLOGIN;